import type { BadgeVariant, MenuItem } from '@/data/menu';
import menu from '@/data/menu';
import { defineStore } from 'pinia';

interface MenuState {
    menu: MenuItem[];
}

function findMenu(m: MenuItem[], badge: string): MenuItem | undefined {
    const found = m.find((i: MenuItem) => i.name === badge);

    if (found) {
        return found;
    }

    return m.flatMap((i: MenuItem) => i.sub ?? []).find((i: MenuItem) => i.name === badge);
}

function findParentMenu(m: MenuItem[], targetName: string): MenuItem | undefined {
    return m.find((i: MenuItem) => i.sub?.some((subItem: MenuItem) => subItem.name === targetName));
}

export const useMenuStore = defineStore('menu', {
    state: (): MenuState => {
        return { menu: menu.main ?? [] };
    },
    actions: {
        addBadge(badge: string, count: number, variant: BadgeVariant = 'primary') {
            const m = findMenu(this.menu, badge);

            if (!m) {
                return;
            }

            m.badge = count.toString();
            m['badge-variant'] = variant;

            // Find and open parent menu if this is a sub-item
            const parent = findParentMenu(this.menu, badge);
            if (parent) {
                parent.open = true;
            }
        },
        removeBadge(badge: string) {
            const m = findMenu(this.menu, badge);

            if (!m) {
                return;
            }

            delete m.badge;
            delete m['badge-variant'];
        },
    },
});
